module.exports = function stopLoop(sample) {
  if (sample && sample.file) {
    sample.file.loop = false
  }
}
